import React from "react";
import { Stack } from "@mui/material";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <Stack style={{ height: "100%", justifyContent: "flex-end" }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13661.409810002015!2d75.9497785!3d31.1277252!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a93c477e212ab%3A0x4a6b298e619eb361!2sMakeup%20Master%20salon%20%26%20Academy!5e0!3m2!1sen!2sin!4v1695317412304!5m2!1sen!2sin"
                  height="450"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                />
              </Stack>
            </div>
            <div className="col-lg-6">
              <div className="contact-form wow fadeInRightBig" id="contact">
                <div className="title">
                  <h2 className="h2-title">Contact</h2>
                  <h3 className="h3-title">Get in Touch</h3>
                </div>
                <div role="form" className="wpcf7" id="wpcf7-f22-o1" lang="en-US" dir="ltr">
                  <div className="screen-reader-response"></div>
                  <form className="wpcf7-form">
                    <div style={{ display: "none" }}>
                      <input type="hidden" name="_wpcf7" value="22" />
                      <input type="hidden" name="_wpcf7_version" value="5.1.7" />
                      <input type="hidden" name="_wpcf7_locale" value="en_US" />
                      <input type="hidden" name="_wpcf7_unit_tag" value="wpcf7-f22-o1" />
                      <input type="hidden" name="_wpcf7_container_post" value="0" />
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <span className="wpcf7-form-control-wrap full-name">
                          <input
                            type="text"
                            name="full-name"
                            value=""
                            size="40"
                            className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required form-input"
                            aria-required="true"
                            aria-invalid="false"
                            placeholder="Your Name*"
                          />
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <span className="wpcf7-form-control-wrap your-email">
                          <input
                            type="email"
                            name="your-email"
                            value=""
                            size="40"
                            className="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email form-input"
                            aria-required="true"
                            aria-invalid="false"
                            placeholder="Your Email*"
                          />
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <span className="wpcf7-form-control-wrap your-message">
                          <textarea
                            name="your-message"
                            cols="40"
                            rows="10"
                            className="wpcf7-form-control wpcf7-textarea form-input"
                            aria-invalid="false"
                            placeholder="Your Message"
                          ></textarea>
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="submit-btn">
                          <button type="submit" className="sec-btn sm-btn">
                            Send Message
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="wpcf7-response-output wpcf7-display-none"></div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 text-center">
              <p className="copyright">Copyright © 2023 Makeup Master. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
